export default "https://cdn-static.gokick.com/assets/fe83fbcc8f1f3696644045565519fd390c3f6ffc/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";